namespace TabAurous.Retail {
    export namespace POSApprovalReturnLaborService {
        export const baseUrl = 'Retail/POSApprovalReturnLabor';

        export declare function Create(request: Serenity.SaveRequest<POSApprovalReturnLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSApprovalReturnLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSApprovalReturnLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalReturnLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/POSApprovalReturnLabor/Create",
            Update = "Retail/POSApprovalReturnLabor/Update",
            Delete = "Retail/POSApprovalReturnLabor/Delete",
            Retrieve = "Retail/POSApprovalReturnLabor/Retrieve",
            List = "Retail/POSApprovalReturnLabor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>POSApprovalReturnLaborService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
